import React, { useState } from "react";
import DatePicker from "../../../../Universal/DatePicker.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import FilterIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";
import "../../../../../styles/Pages/Financial/CashInFlow/Fees/AllFeesCollection.style.css";

const AllCollectionSearchBox = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleFilterChange = (value) => {
    setSelectedFilters((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };
  return (
    <div className="searchBoxContainer">
      <div className="input-boxes">
        <DatePicker
          label="Date"
          name="date"
          setFieldValue={() => {}}
          placeholder={"Choose a date"}
          errors={() => {}}
        />
        <div className="collectionFeesFilterSearchButtonContainer">
          <button onClick={() => setShowFilter(!showFilter)}>
            <img src={FilterIcon} alt="Filter icon" />
            <span className="filterText">Filter</span>
          </button>
          {showFilter && (
            <ul className="filterDropdown">
              {["Class Wise", "Cateogry Wise"].map((role) => (
                <li key={role}>
                  <input
                    type="checkbox"
                    value={role}
                    checked={selectedFilters.includes(role)}
                    onChange={() => handleFilterChange(role)}
                  />
                  <span>{role}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="searchInputContainer">
          <button className="searchBtn">
            <img src={SearchIcon} alt="Search" />
          </button>
          <input
            type="text"
            className="pageHeaderInput"
            placeholder="Search id"
          />
        </div>
      </div>
      <button className="downloadBtn actionBtn">Download</button>
    </div>
  );
};

export default AllCollectionSearchBox;
